import { Routes } from '@angular/router';
import { ErrorComponentComponent } from './error-component/error-component.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    children: [], // Empty children since we want to show AppComponent's own view
  },
  {
    path: 'error',
    component: ErrorComponentComponent,
  },
  { path: '**', redirectTo: '/error' },
];
